export const BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  ERROR: 'error',
  GREY: 'grey',
};

export const BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  FULL_WIDTH: 'full-width',
  ICON_ONLY: 'icon-only',
};

const normalizeButtonSize = (size = BUTTON_SIZES.MEDIUM) => {
  const normalized = `${size || ''}`.trim().toLowerCase();

  if (!normalized) {
    return BUTTON_SIZES.MEDIUM;
  }

  if (normalized === 'fullwidth' || normalized === 'full') {
    return BUTTON_SIZES.FULL_WIDTH;
  }

  if (normalized === 'icononly' || normalized === 'icon') {
    return BUTTON_SIZES.ICON_ONLY;
  }

  if (normalized === BUTTON_SIZES.SMALL || normalized === BUTTON_SIZES.MEDIUM || normalized === BUTTON_SIZES.LARGE || normalized === BUTTON_SIZES.FULL_WIDTH || normalized === BUTTON_SIZES.ICON_ONLY) {
    return normalized;
  }

  return BUTTON_SIZES.MEDIUM;
};

const resolveVariantFromProps = ({
  primary = false,
  secondary = false,
  tertiary = false,
  error = false,
  grey = false,
  variant = '',
  color = '',
}) => {
  const normalizedVariant = typeof variant === 'string' ? variant.trim().toLowerCase() : '';
  const normalizedColor = typeof color === 'string' ? color.trim().toLowerCase() : '';

  if (error || variant === 'error' || color === 'error') return BUTTON_VARIANTS.ERROR;

  if (
    secondary ||
    normalizedVariant === 'secondary' ||
    normalizedVariant === 'outlined' ||
    normalizedColor === 'secondary'
  ) {
    return BUTTON_VARIANTS.SECONDARY;
  }

  if (
    tertiary ||
    normalizedVariant === 'tertiary' ||
    normalizedVariant === 'text' ||
    normalizedColor === 'tertiary'
  ) {
    return BUTTON_VARIANTS.TERTIARY;
  }

  if (
    grey ||
    normalizedVariant === 'grey' ||
    normalizedVariant === 'gray' ||
    normalizedVariant === 'neutral' ||
    normalizedColor === 'grey' ||
    normalizedColor === 'gray'
  ) {
    return BUTTON_VARIANTS.GREY;
  }

  if (
    primary ||
    normalizedVariant === 'primary' ||
    normalizedVariant === 'contained' ||
    normalizedVariant === 'filled' ||
    normalizedColor === 'primary'
  ) {
    return BUTTON_VARIANTS.PRIMARY;
  }

  if (variant) {
    if (
      normalizedVariant === 'contained' ||
      normalizedVariant === 'filled' ||
      normalizedVariant === 'containedprimary'
    ) {
      return BUTTON_VARIANTS.PRIMARY;
    }

    if (normalizedVariant === 'secondary' || normalizedVariant === 'outlined') {
      return BUTTON_VARIANTS.SECONDARY;
    }

    if (normalizedVariant === 'tertiary' || normalizedVariant === 'text') {
      return BUTTON_VARIANTS.TERTIARY;
    }
  }

  return BUTTON_VARIANTS.PRIMARY;
};

export const getButtonVariant = (props = {}) => resolveVariantFromProps(props);

export const getButtonVariantClass = (variant) =>
  `ls-button--${variant || BUTTON_VARIANTS.PRIMARY}`;

export const getButtonSizeClass = (size = BUTTON_SIZES.MEDIUM) =>
  `ls-button--${normalizeButtonSize(size)}`;

export const getButtonLabel = ({ children, label = 'Press Me' } = {}) =>
  children != null ? children : label;

export const getButtonClassName = ({
  variant,
  size = BUTTON_SIZES.MEDIUM,
  className = '',
  loading = false,
}) =>
  `ls-button ${getButtonVariantClass(variant)} ${getButtonSizeClass(size)} ${loading ? 'ls-button--loading' : ''} ${className}`.trim();

export const getButtonHandler = ({ onClick, onPress } = {}) =>
  onClick || onPress;
